export const CAMPAIGNS_API_BASE_PATH = '/api/dashboard/customer/mailing'

export const CAMPAIGNS_API = `${CAMPAIGNS_API_BASE_PATH}/campaigns`
